// helper
import { styleGenerator } from '../../helper';

// constants
import { S_HEIGHT, T_TYPO, NU_TYPO, F_BG, B_BG, G_RADIUS, FG_RADIUS } from './constants';

/**
 * Internal dependencies
 */
const { generateRangeStyles, GlobalStyleHandler, generateTypographyStyles, generateBgStyles, generateResBoxStyles } =
    window.progressmatifyModules;

// Generate Dynamic Style
const DynamicStyle = props => {
    const { attributes, setAttributes } = props;
    const { uniqueId, titleColor, perCentange } = attributes;

    // Gap

    //    // Global
    const {
        deskStyle: sDeskHeight,
        tabStyle: sTabHeight,
        mobStyle: sMobHeight
    } = generateRangeStyles({
        controlName: S_HEIGHT,
        attributes,
        propertyName: 'height'
    });
    const {
        desktopStyles: tDeskTypo,
        tabletStyles: tTabTypo,
        mobileStyles: tMobTypo
    } = generateTypographyStyles({
        controlName: T_TYPO,
        attributes
    });
    const {
        desktopStyles: nuDeskTypo,
        tabletStyles: nuTabTypo,
        mobileStyles: nuMobTypo
    } = generateTypographyStyles({
        controlName: NU_TYPO,
        attributes
    });

    const { bgStyle: fBg } = generateBgStyles({
        controlName: F_BG,
        attributes
    });
    const { bgStyle: bBg } = generateBgStyles({
        controlName: B_BG,
        attributes
    });
    const {
        boxDeskStyles: gDeskBRadius,
        boxTabStyles: gTabBRadius,
        boxMobStyles: gMobBRadius
    } = generateResBoxStyles({
        controlName: G_RADIUS,
        attributes,
        propertyName: 'border-radius',
        forRadius: true
    });
    const {
        boxDeskStyles: fgDeskBRadius,
        boxTabStyles: fgTabBRadius,
        boxMobStyles: fgMobBRadius
    } = generateResBoxStyles({
        controlName: FG_RADIUS,
        attributes,
        propertyName: 'border-radius',
        forRadius: true
    });
    // Desktop Styles
    const deskStyles = `
    
       
         ${styleGenerator(`.${uniqueId} .progressmatify-bar `, [
             {
                 v: sDeskHeight
             }
         ])}
         ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-title `, [
             {
                 v: tDeskTypo
             },
             {
                 p: 'color',
                 v: titleColor
             }
         ])}
         ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-percent `, [
             {
                 p: 'color',
                 v: perCentange
             },
             {
                 v: nuDeskTypo
             }
         ])}
          ${styleGenerator(`.${uniqueId} .progressmatify-bar-fill`, [
              {
                  v: fBg
              },
              {
                  v: fgDeskBRadius
              }
          ])}
           ${styleGenerator(`.${uniqueId} .progressmatify-bar`, [
               {
                   v: bBg
               },
               {
                   v: gDeskBRadius
               }
           ])}
          
    `;
    const tabStyles = `
       
         ${styleGenerator(`.${uniqueId} .progressmatify-bar `, [
             {
                 v: sTabHeight
             }
         ])}
           ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-title `, [
               {
                   v: tTabTypo
               }
           ])}
            ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-percent `, [
                {
                    v: nuTabTypo
                }
            ])}
             ${styleGenerator(`.${uniqueId} .progressmatify-bar-fill`, [
                 {
                     v: fgTabBRadius
                 }
             ])}
           ${styleGenerator(`.${uniqueId} .progressmatify-bar`, [
               {
                   v: gTabBRadius
               }
           ])}
    `;
    const mobStyles = `
        
         ${styleGenerator(`.${uniqueId} .progressmatify-bar `, [
             {
                 v: sMobHeight
             }
         ])}
           ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-title `, [
               {
                   v: tMobTypo
               }
           ])}
           ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-percent `, [
               {
                   v: nuMobTypo
               }
           ])}
            ${styleGenerator(`.${uniqueId} .progressmatify-bar-fill`, [
                {
                    v: fgMobBRadius
                }
            ])}
           ${styleGenerator(`.${uniqueId} .progressmatify-bar`, [
               {
                   v: gMobBRadius
               }
           ])}
           
    `;

    return (
        <GlobalStyleHandler
            attributes={attributes}
            setAttributes={setAttributes}
            deskStyles={deskStyles}
            tabStyles={tabStyles}
            mobStyles={mobStyles}
        />
    );
};

export default DynamicStyle;
